// extracted by mini-css-extract-plugin
export default {"linkStyle":"linkStyle--HYh2a"};